import { render } from "./CobaltSimpleTaskForm.vue?vue&type=template&id=17a55177"
import script from "./CobaltSimpleTaskForm.vue?vue&type=script&lang=js"
export * from "./CobaltSimpleTaskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__